import { forwardRef } from 'react';
import Textarea from '../../../textarea';
import { Props as TextareaProps } from '../../../textarea/types';

type Props = {
  textareaProps?: TextareaProps & {
    helperText?: string;
  };
};

const SearchBox = forwardRef<HTMLDivElement, Props>(
  ({ textareaProps }, ref) => {
    return (
      <Textarea
        {...textareaProps}
        ref={ref}
      />
    );
  },
);

SearchBox.displayName = 'SearchWidget.SearchBox';

export default SearchBox;
